import cn from 'classnames'
import React, { InputHTMLAttributes, useEffect, useMemo, useRef } from 'react'
//import { Counter } from '../../pages/EventForm/components/Counter/Counter.tsx'
import { useTranslation } from 'react-i18next'
import styles from './Input.module.less'

interface Props extends Omit<InputHTMLAttributes<HTMLTextAreaElement>, 'value'> {
    onValueChange?: (value: string) => void
    limit?: number
    initialValue?: string
}

const LimitValidation: React.FC<{ height?: string; value: string; limit: number; withCounter: boolean }> = ({
    height,
    withCounter,
    value,
    limit
}) => {
    const [text, overflowText] = useMemo(() => [value?.slice(0, limit) || '', value?.slice(limit) || ''], [limit, value])
    return (
        <>
            <div style={{ height, minHeight: 120 }} className={styles.valueWithOverflowStyles}>
                {text}
                <em>{overflowText}</em>
            </div>
            {/*{withCounter && (*/}
            {/*    <div className={styles.limitCounter}>*/}
            {/*        <Counter count={text.length + overflowText.length} max={limit} min={0} />*/}
            {/*    </div>*/}
            {/*)}*/}
        </>
    )
}

export const Textarea: React.FC<Props> = ({ initialValue = '', limit, onValueChange, ...props }) => {
    const [value, setValue] = React.useState<string>(initialValue)
    const ref = useRef<HTMLTextAreaElement | null>(null)
    const [focused, setFocused] = React.useState<boolean>(false)
    const { t } = useTranslation()
    const [dirty, setDirty] = React.useState<boolean>(false)
    const [height, setHeight] = React.useState('')
    const handleResize = () => {
        if (ref.current) {
            ref.current.style.height = 'auto'
            ref.current.style.height = ref.current.scrollHeight + 'px'
            setHeight(ref.current?.style.height)
        }
    }

    useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    useEffect(() => {
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        handleResize()
    }, [value])

    useEffect(() => {
        if (!ref.current) return
        if (limit && limit < value.length) {
            ref.current.setCustomValidity(t('Text is too long'))
        } else {
            ref.current.setCustomValidity('')
        }
    }, [limit, t, value])

    return (
        <div className={cn(styles.textAreaRoot, { [styles.disabled]: props.disabled })}>
            {limit && <LimitValidation height={height} withCounter={focused} limit={limit} value={value} />}
            <textarea
                disabled={props.disabled}
                className={cn(styles.root, {
                    [styles.dirty]: dirty,
                    [styles.withLimit]: limit
                })}
                ref={ref}
                value={value || ''}
                {...props}
                onFocus={() => setFocused(true)}
                onBlur={() => {
                    setFocused(false)
                    setDirty(true)
                }}
                onChange={e => {
                    setValue(e.target.value)
                    onValueChange && onValueChange(e.target.value)
                }}
            />
        </div>
    )
}
